import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-payg-payment-success',
  templateUrl: './payg-payment-success.component.html',
  styleUrl: './payg-payment-success.component.css',
  standalone: false
})
export class PaygPaymentSuccessComponent {

  sessionId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.sessionId =
      this.route.snapshot.queryParamMap.get('session_id');

    console.log('Stripe Checkout Session ID:', this.sessionId);
  }

  goToPayg() {
    this.router.navigate(['/admin-payg']);
  }
}
